import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Pattern = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.fabricPatterList);

	const patternResponse =
		data.length > 0
			? [
					{
						name: 'All',
						id: 'ALL',
						count: data.reduce((acc, item) => acc + (item?.count || 0), 0)
					},
					...data.map((item) => ({
						...item,
						additionalImage: item?.additionalInfo
					}))
				]
			: [];

	return (
		<>
			<FilterName type="PATTERN" />
			<Checkbox data={patternResponse} type="PATTERN" handleSearch={handleSearch} />
		</>
	);
};

export default Pattern;
